// extracted by mini-css-extract-plugin
export default {"searchArea":"Category_searchArea__sLIHE","search":"Category_search__IH456","select":"Category_select__+Z6dL"};